import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireAccess = false, redirectTo = "/login" }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-[var(--app-text-soft)]" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) {
    return <Navigate to={redirectTo} state={{ from: loc.pathname }} replace />;
  }
  if (requireAccess && !user.has_access) {
    return <Navigate to="/trial-expired" replace />;
  }
  return children;
}
